import type { Faro } from '@grafana/faro-core';
import {
  ConsoleInstrumentation,
  ErrorsInstrumentation,
  FetchTransport,
  initializeFaro,
  LogLevel,
} from '@grafana/faro-web-sdk';

declare global {
  interface Window {
    plgFaro?: Faro;
  }
}

export default defineNuxtPlugin(() => {
  const { public: { faroEnabled, faroEndpoint } } = useRuntimeConfig();
  if (window.plgFaro || !faroEnabled) {
    return;
  }

  initializeFaro({
    app: {
      name: 'portal-ui-client', // name differently so we can differentiate browser and app logs
    },
    globalObjectKey: 'plgFaro',
    instrumentations: [
      new ErrorsInstrumentation(),
      new ConsoleInstrumentation({
        consoleErrorAsLog: true,
        disabledLevels: [
          LogLevel.TRACE,
          LogLevel.DEBUG,
          LogLevel.INFO,
          LogLevel.WARN,
          LogLevel.LOG,
        ],
      }),
    ],
    transports: [
      new FetchTransport({
        url: faroEndpoint,
      }),
    ],
  });
});
